import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import * as E from '../../elementor'
import Table from './Table'
import parse from 'html-react-parser'
import SmoothScrollLink from '../transition/smooth-scroll-link'

type Props = {
  section: E.Section<true>
  hideCTA?: boolean
}

const ByTheNumbers = ({ section, hideCTA = false }: Props) => {
  const { heading, textEditor, image, button, table, blockQuote } = E.collect(section)
  const isScrollLink = button[0]?.link !== undefined && button[0]?.link.includes('#');
  const imageUrl = `url(${image[0]?.image?.fileUrl})`
  const imageStyle = {
    backgroundImage: `linear-gradient(to bottom, transparent 30%, black 100%), ${imageUrl}`,
    backgroundSize: 'cover'
  }

  if (section.cssClasses?.includes('no-shadow')) {
    imageStyle.backgroundImage = imageUrl
  }

  return (
    <section>
      <div className='by-the-numbers-wrapper'>
        <div className='text-content'>
          <div className='text-wrapper'>
            <h2>{parse(heading[0]?.title || '')}</h2>
            <p className='paragraph'>{parse(textEditor[0]?.text() || '')}</p>
            <Table table={table[0]} />
            {!!hideCTA ? <></> : (
              <div className='button-wrapper'>
                {button[0] ? isScrollLink ?
                  <SmoothScrollLink offset={0} offsetMobile={0} id={button[0].link as string} className='main-button'><button className='rula-button'>{button[0]?.text}</button></SmoothScrollLink> :
                  <AniLink id={button[0]?.button_css_id || ''} className='main-button' fade to={button[0]?.link}><button className='rula-button'>{button[0]?.text}</button></AniLink>
                : null}
              </div>
            )}
          </div>
        </div>
        <div className='image' style={imageStyle}>
          <div className='quote'>
            {(image[1]) && (
              <div className='quote-img-container'>
                <img className='quote-img' src={image[1]?.image?.fileUrl} alt={image[1]?.image?.altText} />
              </div>
            )}
            <p className='subhead s4 content'>{parse(blockQuote[0]?.blockquote_content || '')}</p>
            <p className='paragraph-large author'>{parse(blockQuote[0]?.author_name || '')}</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ByTheNumbers
